<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true                    //控制视图是否显示的变量
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true         //再打开
      })
    }
  },
}
</script>

<style>
@font-face {
  font-family: 'Calibri';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: local('Calibri'), url(./assets/Calibri.woff2) format('woff2');
}
@font-face {
  font-family: 'GoogleSans-Regular';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url("./assets/Fonts/GoogleSans-Regular.woff2");
}
@font-face {
  font-family: 'GoogleSans-Medium';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url("./assets/Fonts/GoogleSans-Medium.woff2");
}
@font-face {
  font-family: 'GoogleSans-Bold';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url("./assets/Fonts/GoogleSans-Bold.woff2");
}
@font-face {
  font-family: 'Roboto-Regular';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url("./assets/Fonts/Roboto-Regular.woff2");
}
@font-face {
  font-family: 'Roboto-Medium';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url("./assets/Fonts/Roboto-Medium.woff2");
}
@font-face {
  font-family: 'Roboto-Bold';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url("./assets/Fonts/Roboto-Bold.woff2");
}
/*  通用配置  */
#app {
  font-family: GoogleSans-Regular, Helvetica, Arial, sans-serif;
  color: #000;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
body {
  height: auto;
  font-family: GoogleSans-Regular, Helvetica, Arial, sans-serif;
}·
/*  主题样式配置  */
.ant-page-header-tl {
  padding: 16px 24px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
  font-size: 16px;
  font-weight: 600;
}
</style>
